<template>
  <div>
    <div class="cover">
      <video 
        class="video" 
        autoplay 
        muted 
        loop 
        playsinline 
        :poster="`${cdn_archivos_dominio}/portada/flores_v2.webp`"
        >
        <source 
          :src="`${cdn_archivos_dominio}/portada/flores_v2.webm`" 
          type="video/webm">
      </video>

      <div class="cover-gradient">
        <h1 class="cover-title a11y-contraste-fondo">Búsqueda de alternativas al glifosato</h1>
        <h2 class="cover-subtitle a11y-contraste-fondo">
          Un capítulo del Ecosistema Nacional Informático de {{obtenerNombreEni}}
        </h2>
      </div>
    </div>

    <div class="container text m-t-3 m--b-2 a11y-simplificada-block">
      <h2 class="titular-portada m-t-3-sm m-t-4-md m-x-auto">
        Búsqueda de alternativas al glifosato
      </h2>
      <h2 class="titular-portada sub m-x-auto">
        Un capítulo del Ecosistema Nacional Informático de {{obtenerNombreEni}}
      </h2>
    </div>

    <div id="story">
      <h2 id="story-title">
        ¿Qué es el <b>glifosato</b>?
      </h2>

      <div class="story-steep">
        <p class="story-txt">Es un agroquímico que se usa para la <b>eliminación de hierbas no deseadas</b> en los campos agrícolas, los parques, las carreteras y algunos cuerpos de agua.</p>
        <div class="story-images img-a11y-hidde">
          <img class="" src="@/assets/img/scrollytelling/campesino.png" alt="">
        </div>
      </div>

      <div class="story-steep">
        <p class="story-txt">Es el <b>herbicida más utilizado en México</b> debido a que las políticas neoliberales promovieron un modelo de máximas ganancias económicas sin considerar los daños ambientales y a la salud, así como el éxodo rural y la escasez de mano de obra.</p>
        <div class="story-images img-a11y-hidde">
          <img class="" src="@/assets/img/scrollytelling/mexico.png" alt="">
        </div>
      </div>

      <div class="story-steep">
        <p class="story-txt">Existen más de mil estudios científicos que muestran los múltiples y <b>graves daños a la salud</b> del glifosato, así como su enorme impacto al ambiente. <small aria-hidden="true" class="story-credit since-tab-block">Crédito de fotografía: Jesús Lozano Kasten</small></p>
        <div class="story-images img-a11y-hidde">
          <img class="" src="@/assets/img/scrollytelling/acuerdo.png" alt="">
        </div>
        <small aria-hidden="true" class="story-credit on-cel-block">Crédito de fotografía: Jesús Lozano Kasten</small>
      </div>

      <div class="story-steep">
        <p class="story-txt">El actual gobierno de México ha establecido un <b>Decreto Presidencial</b> para sustituir, con límite al 2024, la importación, distribución, promoción y uso de este agrotóxico.</p>
        <div class="story-images img-a11y-hidde">
          <img class="" src="@/assets/img/scrollytelling/decreto.png" alt="">
        </div>
      </div>

      <div class="story-steep">
        <p class="story-txt">El Conahcyt se encuentra promoviendo investigaciones científicas, desarrollos tecnológicos e innovaciones para sustentar y proponer <b>alternativas ecológicas, seguras para la salud humana y culturalmente adecuadas</b> que permitan prescindir gradualmente del glifosato.</p>
        <div class="story-images img-a11y-hidde">
          <img class="" src="@/assets/img/scrollytelling/aguacate.png" alt="">
        </div>
      </div>

      <div class="repositorio">
        <div class="container">
          <DownloadImportantFileBajo
            file="descargables/repositorio/glifosato.pdf" 
            type="application/pdf" 
            format="PDF" 
            name="Expediente científico sobre el glifosato y los cultivos GM"
            downloadname="expediente-cientifico-sobre-el-glifotato-y-los-cultivos-gm.pdf" 
            weight="3.9 MB" 
            cover="descargables/repositorio/expediente_inicio.png" />

          <LinkCoverImg 
            class="m-t-2"
            title="Compilado de información científica sobre el glifosato" 
            :url="url"
            target="_blank"
            :cover="require(`@/assets/img/repositorio-link.png`)"
            size="full"
          />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex';

import LinkCoverImg from "@/components/base/LinkCoverImg.vue";
import DownloadImportantFileBajo from '@/components/DownloadImportantFileBajo.vue';

export default {
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      url: "https://conahcyt.mx/cibiogem/index.php/sistema-nacional-de-informacion/documentos-y-actividades-en-bioseguridad/repositorio-glifosato#:~:text=La%20intenci%C3%B3n%20de%20generar%20este,enfoque%20del%20principio%20de%20precauci%C3%B3n"
    }
  },
  computed: {
    ...mapState(["cdn_archivos_dominio"]),
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
  },
  components:{
    LinkCoverImg,
    DownloadImportantFileBajo,
  },
  mounted() {},
  unmounted() {
    this.rellax.destroy()
  }
}
</script>

<style scoped lang="scss">
.cover {
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    &.hidden{
      display: none;
    }
  }
}

.repositorio {
  background: #E7FDDA;
  padding: $space*1 0;
  margin-top: $space;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    padding: $space*3;
    margin-top: $space * 2;
    .container {
      display: flex;
      flex-direction: column;
    }
  }
}

// storytelling
#story {
  box-sizing: content-box;
  width: 100%;
  overflow: hidden;
  margin-top: $space * 2 0;
  padding: 0;
}
#story-title {
  color: $story;
  font-size: 24px;
  font-weight: normal;
  line-height: 1.1em;
  text-transform: uppercase;
  padding: $space*2 $space * .5;
  margin: 0;
  margin-bottom: - ($space*1.5);
  text-align: center;
  b {
    font-weight: bold;
  }
  @media (min-width: $breakpoint-tablet) {
    font-size: 28px;
  }
}
.story-steep {
  box-sizing: content-box;
  color: $gris;
  margin: auto;
  padding: $space*.5 $space;
  text-align: center;
  // margin-bottom: $space * .5;
  .story-txt {
    box-sizing: content-box;
    margin: $space * .5;
    line-height: 1.5em;
  }
  .story-credit {
    position: relative;
    font-size: 12px;
    top: -#{$space};
  }
  .story-images {
    box-sizing: content-box;
    width: 100%;
    margin: $space auto;
    // height: 250px;
    img {
      position: relative;
      max-width: 100%;
    }
  }
  
  @media (max-width: $breakpoint-tablet) {
    &::after {
      content: "";
      height: 2px;
      width: 30%;
      display: block;
      margin: 0 auto;
      background-color: $story;
    }
  }
  @media (min-width: $breakpoint-tablet) {
    display: flex;
    align-items: center;
    justify-content: center;
    .story-txt {
      display: block;
      position: relative;
      flex: 1 1 520px;
      max-width: 520px;
      margin: $space;
      padding: 0;
      
      font-size: 22px;
      line-height: 1.5em;
      &::after {
        content: "";
        height: 2px;
        width: 30%;
        display: block;
        margin: $space auto 0;
        background-color: $story;
      }
    }
    .story-credit {
      position: absolute;
      top: inherit;
      bottom: -#{$space*1.75};
      left: 0;
      right: 0;
    }
    .story-images {
      flex: 1;
      margin: 0;
      max-width: 350px;
    }
    &:nth-child(even) {
      flex-direction: row-reverse;
    }
  }
}
</style>
